import {
  Button,
  Modal,
  Space,
  Table,
  TablePaginationConfig,
  Tag,
  Tooltip,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import moment from "moment/moment";
import { QueryObserverResult } from "react-query";
import { TPagination } from "../../types/common/TPagination";
import { FilterValue } from "antd/es/table/interface";
import { TBusinessUser } from "../../types/BusinessUser/TBusinessUser";

const BusinessUserTable = ({
  data,
  onEdit,
  onChange,
  isLoading,
  deleteUser,
  refetch,
}: {
  data?: TPagination<TBusinessUser[]>;
  onEdit?(user: TBusinessUser): void;
  onChange?(
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>
  ): void;
  isLoading?: boolean;
  deleteUser?(id: string): Promise<void>;
  refetch?(): Promise<
    QueryObserverResult<TPagination<TBusinessUser[]>, unknown>
  >;
}) => {
  return (
    <Table
      columns={[
        {
          title: "#",
          dataIndex: "index",
          key: "no",
        },
        {
          title: "full name",
          dataIndex: "first_name",
          key: "first_name",
        },
        {
          title: "email",
          dataIndex: "email",
          key: "email",
        },
        {
          title: "address",
          dataIndex: "address",
          key: "address",
        },
        {
          title: "phone",
          dataIndex: "phone",
          key: "phone",
        },
        {
          title: "created at",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "Is Active",
          dataIndex: "is_active",
          key: "is_active",
          render: (tag: boolean) => (
            <Tag color={tag ? "geekblue" : "red"}>{tag ? "True" : "False"}</Tag>
          ),
          filters: [
            {
              text: "True",
              value: true,
            },
            {
              text: "False",
              value: false,
            },
          ],
        },
        {
          title: "Actions",
          dataIndex: "action",
          key: "action",
          render: ({ id }: { id: string }) => (
            <Space>
              <Tooltip title="Edit User">
                <Button
                  onClick={() => {
                    if (data?.data) {
                      const user = data.data.find((user) => user.id === id);
                      if (user) {
                        onEdit && onEdit(user);
                      }
                    }
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>

              <Tooltip title="Delete User">
                <Button
                  icon={<DeleteOutlined />}
                  onClick={() =>
                    Modal.confirm({
                      title: "User",
                      icon: <ExclamationCircleFilled />,
                      content: "Do you want to delete this user ?",
                      onOk: () =>
                        deleteUser &&
                        deleteUser(id).then(() => {
                          refetch && refetch();
                        }),
                    })
                  }
                  danger
                />
              </Tooltip>
            </Space>
          ),
        },
      ]}
      dataSource={data?.data?.map((u: TBusinessUser, i: number) => ({
        index: i + 1,
        first_name: u.first_name + " " + u.second_name,
        email: u.email,
        address: u.address,
        phone: u.phone,
        created_at: u.created_at
          ? moment(u.created_at).format("YYYY-MM-DD")
          : "",
        is_active: u.is_active,
        action: { id: u.id },
        key: u.id,
      }))}
      pagination={{
        total: data?.total,
      }}
      onChange={onChange}
      loading={isLoading}
    />
  );
};

export default BusinessUserTable;
